import { useSyncExternalStore } from "react";

const TOKEN_KEY = "ingatlan_admin_token";
const listeners = new Set<() => void>();

function notify() {
  for (const l of listeners) l();
}

export function getAccessToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setAccessToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* ignore */
  }
  notify();
}

export function clearAccessToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
  notify();
}

export function useAccessToken(): string | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    getAccessToken,
    () => null,
  );
}

export function useIsAuthenticated(): boolean {
  return Boolean(useAccessToken());
}
